export const CDN_URL = process.env.CDN_URL
  ? process.env.CDN_URL
  : 'https://cdn.geniebook.dev/';
export const BASE_URL = process.env.BASE_URL
  ? process.env.BASE_URL
  : 'https://dev.geniebook.dev/';
